import api from '.';
import { PaginationProps } from '../common/interface/pagination';
import { DocumentGroup } from '../pages/MasterData/DocumentGroup/documentGroupSlice';

export interface GetDocumentGroupMasterDataParams extends PaginationProps {
  disciplineId: number | null;
}

export interface CreateDocumentGroup {
  name: string;
  order: number;
  disciplineId: number;
}

export interface UpdateDocumentGroup extends CreateDocumentGroup {
  id: number;
}

interface ReturnTypeDocumentGroup {
  data: DocumentGroup[];
}

interface ReturnTypeDocumentGroupMasterData extends ReturnTypeDocumentGroup {
  count: number;
}

export async function getDocumentGroups(): Promise<ReturnTypeDocumentGroup> {
  const { data } = await api.get('/document-groups');

  return data;
}

export async function getDocumentGroupsMasterData(
  params: GetDocumentGroupMasterDataParams
): Promise<ReturnTypeDocumentGroupMasterData> {
  const { data } = await api.get('/document-groups/master-data', { params });

  return data;
}

export async function getDocumentGroup(id: number): Promise<DocumentGroup> {
  const { data } = await api.get(`/document-groups/${id}`);

  return data;
}

export async function createDocumentGroup(
  createDocumentGroup: CreateDocumentGroup
): Promise<DocumentGroup> {
  const { data } = await api.post('/document-groups', createDocumentGroup);

  return data;
}

export async function updateDocumentGroup(
  updateDocumentGroup: UpdateDocumentGroup
): Promise<DocumentGroup> {
  const { data } = await api.put(
    `/document-groups/${updateDocumentGroup.id}`,
    updateDocumentGroup
  );

  return data;
}

export async function deleteDocumentGroup(id: number): Promise<void> {
  return api.delete(`/document-groups/${id}`);
}
